import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconResources = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M0 2.75C0 1.25 1.21875 0 2.75 0H12.25C13.1875 0 14 0.8125 14 1.75V10.75C14 11.4688 13.5625 12.0625 13 12.3438V14.5H13.25C13.6562 14.5 14 14.8438 14 15.25C14 15.6875 13.6562 16 13.25 16H2.5C1.09375 16 0 14.9062 0 13.5C0 13.4375 0 13.3438 0 13.25V2.75ZM2.5 12.5C1.9375 12.5 1.5 12.9688 1.5 13.5C1.5 14.0625 1.9375 14.5 2.5 14.5H11.5V12.5H2.5ZM1.5 11.2188C1.78125 11.0938 2.125 11 2.5 11H12.25C12.375 11 12.5 10.9062 12.5 10.75V1.75C12.5 1.625 12.375 1.5 12.25 1.5H2.75C2.03125 1.5 1.5 2.0625 1.5 2.75V11.2188ZM4.75 3.5H10.25C10.6562 3.5 11 3.84375 11 4.25C11 4.6875 10.6562 5 10.25 5H4.75C4.3125 5 4 4.6875 4 4.25C4 3.84375 4.3125 3.5 4.75 3.5ZM4.75 6H10.25C10.6562 6 11 6.34375 11 6.75C11 7.1875 10.6562 7.5 10.25 7.5H4.75C4.3125 7.5 4 7.1875 4 6.75C4 6.34375 4.3125 6 4.75 6Z" })]
});
const ForwardRef = forwardRef(SvgIconResources);
export { ForwardRef as ReactComponent };
